import React, { useEffect, useMemo, useState } from "react"
import { useNavigate } from "react-router-dom"
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  UncontrolledDropdown,
  UncontrolledTooltip,
} from "reactstrap"

import Breadcrumbs from "components/Common/BreadcrumbTitle"
import AppConstant from "../../constants/app.constants"

import TableContainerV1 from "../../components/Common/TableContainerV1"

import { getNotificationTemplate } from "../../helpers/UAM/notificationTemplate.helper";
import { getTemplate } from "../../helpers/UAM/emailTemplate.helper";
import { getSMSTemplate } from "../../helpers/UAM/sms.helper";
// import { useToast } from "ToastStore"
import ToastDialog from "components/Common/ToastDialog"

const EmailTableActionsComponent = (rowData) => {
  const navigate = useNavigate();
  const { roleName } = JSON.parse(localStorage.getItem("user"))

  const navigateToeEditEmail = id => {
    const encryptedId = btoa(id.toString())
    navigate(`/${roleName}/email-template/edit?id=${encodeURIComponent(encryptedId)}`)
  }
  const navigateToeViewEmail = id => {
    const encryptedId = btoa(id.toString())
    navigate(`/${roleName}/email-template/view?id=${encodeURIComponent(encryptedId)}`)
  }

  return (
    <UncontrolledDropdown>
      <DropdownToggle tag="a" className="card-drop">
        <i className="mdi mdi-dots-horizontal font-size-18"></i>
      </DropdownToggle>

      <DropdownMenu className="dropdown-menu-end">
        <DropdownItem
          onClick={() => {
            navigateToeViewEmail(rowData.id)
          }}
        >
          <i
            className="mdi mdi-eye font-size-16 text-success me-1"
            id="viewtooltip"
          ></i>
          View
          <UncontrolledTooltip placement="top" target="viewtooltip">
            View
          </UncontrolledTooltip>
        </DropdownItem>
        <DropdownItem
          onClick={() => {
            navigateToeEditEmail(rowData.id)
          }}
        >
          <i
            className="mdi mdi-pencil font-size-16 text-success me-1"
            id="edittooltip"
          ></i>
          Edit
          <UncontrolledTooltip placement="top" target="edittooltip">
            Edit
          </UncontrolledTooltip>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}

const SMSTableActionsComponent = (rowData) => {
  const navigate = useNavigate();
  const { roleName } = JSON.parse(localStorage.getItem("user"))

  const navigateToEditSMS = id => {
    const encryptedId = btoa(id.toString())
    navigate(`/${roleName}/sms-template/edit?id=${encodeURIComponent(encryptedId)}`)
  }
  const navigateToViewSMS = id => {
    const encryptedId = btoa(id.toString())
    navigate(`/${roleName}/sms-template/view?id=${encodeURIComponent(encryptedId)}`)
  }

  return (
    <UncontrolledDropdown>
      <DropdownToggle tag="a" className="card-drop">
        <i className="mdi mdi-dots-horizontal font-size-18"></i>
      </DropdownToggle>

      <DropdownMenu className="dropdown-menu-end">
        <DropdownItem
          onClick={() => {
            navigateToViewSMS(rowData.id)
          }}
        >
          <i
            className="mdi mdi-eye font-size-16 text-success me-1"
            id="viewtooltip"
          ></i>
          View
          <UncontrolledTooltip placement="top" target="viewtooltip">
            View
          </UncontrolledTooltip>
        </DropdownItem>
        <DropdownItem
          onClick={() => {
            navigateToEditSMS(rowData.id)
          }}
        >
          <i
            className="mdi mdi-pencil font-size-16 text-success me-1"
            id="edittooltip"
          ></i>
          Edit
          <UncontrolledTooltip placement="top" target="edittooltip">
            Edit
          </UncontrolledTooltip>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}


const NotificationTableActionsComponent = (rowData) => {
  const navigate = useNavigate();
  const { roleName } = JSON.parse(localStorage.getItem("user"))


  const navigateToditNotification = id => {
    const encryptedId = btoa(id.toString())
    navigate(
      `/${roleName}/notification-template/edit?id=${encodeURIComponent(encryptedId)}`
    )
  }
  const navigateToViewNotification = id => {
    const encryptedId = btoa(id.toString())
    navigate(
      `/${roleName}/notification-template/view?id=${encodeURIComponent(encryptedId)}`
    )
  }
  return (
    <UncontrolledDropdown>
      <DropdownToggle tag="a" className="card-drop">
        <i className="mdi mdi-dots-horizontal font-size-18"></i>
      </DropdownToggle>

      <DropdownMenu className="dropdown-menu-end">
        <DropdownItem
          onClick={() => {
            navigateToViewNotification(rowData.id)
          }}
        >
          <i
            className="mdi mdi-eye font-size-16 text-success me-1"
            id="viewtooltip"
          ></i>
          View
          <UncontrolledTooltip placement="top" target="viewtooltip">
            View
          </UncontrolledTooltip>
        </DropdownItem>
        <DropdownItem
          onClick={() => {
            navigateToditNotification(rowData.id)
          }}
        >
          <i
            className="mdi mdi-pencil font-size-16 text-success me-1"
            id="edittooltip"
          ></i>
          Edit
          <UncontrolledTooltip placement="top" target="edittooltip">
            Edit
          </UncontrolledTooltip>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}

const EmailTemplate = props => {
  //meta title
  document.title = "Template | DMS"
  const { roleName } = JSON.parse(localStorage.getItem("user"))

  const navigate = useNavigate()

  const urlParams = new URLSearchParams(window.location.search)
  const encodedTemplate = urlParams.get("temp")
  const decodedTemplate = atob(encodedTemplate)
  const [templateList, setTemplateList] = useState([])
  const [smsTemplateList, setSmsTemplateList] = useState([])
  const [notificationTemplateList, setNotificationTemplateList] = useState([])

  const [showEmailTable, setShowEmailTable] = useState(false)
  const [showSmsTable, setShowSmsTable] = useState(false)
  const [showNotificationTable, setShowNotificationTable] = useState(false)
  const [selectedValue, setSelectedValue] = useState("0")

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageCount: 0,
    totalRecords: 0,
  })
  const [paginationForSMS, setPaginationForSMS] = useState({
    pageIndex: 0,
    pageCount: 0,
    totalRecords: 0,
  })
  const [paginationForNotification, setPaginationForNotification] = useState({
    pageIndex: 0,
    pageCount: 0,
    totalRecords: 0,
  })

  const [pageSize, setPageSize] = useState(10)
  const [searchValue, setSearchValue] = useState("")
  const [columnId, setColumnId] = useState("id")
  const [sortingOrderStatus, setSortingOrderStatus] = useState("desc")
  const [sortingOptions, setSortingOptions] = useState({
    column: "id",
    isAsc: false,
    optionalColumn: ["Action"],
  })

  const [pageSizeForSMS, setPageSizeForSMS] = useState(10)
  const [searchValueForSMS, setSearchValueForSMS] = useState("")
  const [columnIdForSMS, setColumnIdForSMS] = useState("id")
  const [sortingOrderStatusForSMS, setSortingOrderStatusForSMS] = useState("desc")
  const [sortingOptionsForSMS, setSortingOptionsForSMS] = useState({
    column: "id",
    isAsc: false,
    optionalColumn: ["Action"],
  })

  const [pageSizeForNotification, setPageSizeForNotification] = useState(10)
  const [searchValueForNotification, setSearchValueForNotification] = useState("")
  const [columnIdForNotification, setColumnIdForNotification] = useState("id")
  const [sortingOrderStatusForNotification, setSortingOrderStatusForNotification] = useState("desc")
  const [sortingOptionsForNotification, setSortingOptionsForNotification] = useState({
    column: "id",
    isAsc: false,
    optionalColumn: ["Action"],
  })

  // const { message, showToast, role, handleHideToast } = useToast()
  
  // Customber Column
  const columns = useMemo(
    () => [
      {
        Header: "Id",
        accessor: "id",
        filterable: true,
        Cell: cellProps => {
          return cellProps.value
        },
      },
      {
        Header: "Type",
        accessor: "emailType",
        filterable: true,
        Cell: cellProps => {
          return cellProps.value
        },
      },
      {
        Header: "Subject",
        accessor: "subject",
        filterable: true,
        Cell: cellProps => {
          return cellProps.value
        },
      },
      {
        Header: "Action",
        Cell: cellProps => {
          const rowData = cellProps.row.original
          return EmailTableActionsComponent(rowData)
        },
      },
    ],
    []
  )

  const SMScolumns = useMemo(
    () => [
      {
        Header: "Id",
        accessor: "id",
        filterable: true,
        Cell: cellProps => {
          return cellProps.value
        },
      },
      {
        Header: "Type",
        accessor: "smsType",
        filterable: true,
        Cell: cellProps => {
          return cellProps.value
        },
      },
      {
        Header: "Description",
        accessor: "description",
        filterable: true,
        Cell: cellProps => {
          return cellProps.value
        },
      },
      {
        Header: "Action",
        Cell: cellProps => {
          const rowData = cellProps.row.original
          return SMSTableActionsComponent(rowData)
        },
      },
    ],
    []
  )

  const Notificationcolumns = useMemo(
    () => [
      {
        Header: "Id",
        accessor: "id",
        filterable: true,
        Cell: cellProps => {
          return cellProps.value
        },
      },
      {
        Header: "Type",
        accessor: "notificationType",
        filterable: true,
        Cell: cellProps => {
          return cellProps.value
        },
      },
      {
        Header: "Purpose",
        accessor: "purpose",
        filterable: true,
        Cell: cellProps => {
          return cellProps.value
        },
      },
      {
        Header: "Action",
        Cell: cellProps => {
          const rowData = cellProps.row.original
          return NotificationTableActionsComponent(rowData)
        },
      },
    ],
    []
  )

  useEffect(() => {
    if (decodedTemplate == "sms") {
      setShowSmsTable(true)
      setSelectedValue("sms")
    }
    if (decodedTemplate == "email") {
      setShowEmailTable(true)
      setSelectedValue("email")
    }
    if (decodedTemplate == "notification") {
      setShowNotificationTable(true)
      setSelectedValue("notification")
    }
  }, [])

  useEffect(() => {
    getTemplate({ page: 1, limit: AppConstant.TABLE_RECORD_SIZE })
      .then(responseFromAPI => {
        if (responseFromAPI.status && responseFromAPI.code == 200) {
          setTemplateList(responseFromAPI.data.data)
          const { totalItems, totalPages, currentPage } = responseFromAPI.data
          setPagination({
            pageIndex: currentPage,
            pageCount: totalPages,
            totalRecords: totalItems,
          })
        }
      })
      .catch(error => {

      })

    getNotificationTemplate({ page: 1, limit: AppConstant.TABLE_RECORD_SIZE })
      .then(responseFromAPI => {
        if (responseFromAPI.status && responseFromAPI.code == 200) {
          setNotificationTemplateList(responseFromAPI.data.data)
          const { totalItems, totalPages, currentPage } = responseFromAPI.data
          setPaginationForNotification({
            pageIndex: currentPage,
            pageCount: totalPages,
            totalRecords: totalItems,
          })
        }
      })
      .catch(error => {

      })

    getSMSTemplate({ page: 1, limit: AppConstant.TABLE_RECORD_SIZE })
      .then(responseFromAPI => {
        if (responseFromAPI.status && responseFromAPI.code == 200) {
          setSmsTemplateList(responseFromAPI.data.data)
          const { totalItems, totalPages, currentPage } = responseFromAPI.data
          setPaginationForSMS({
            pageIndex: currentPage,
            pageCount: totalPages,
            totalRecords: totalItems,
          })
        }
      })
      .catch(error => {

      })
  }, [])


  const handleInputChange = e => {
    setSelectedValue(e.target.value)
    if (e.target.value == "email") {
      setShowEmailTable(true)
      setShowSmsTable(false)
      setShowNotificationTable(false)
      navigate(`/${roleName}/email-template`)
    } else if (e.target.value == "sms") {
      setShowSmsTable(true)
      setShowEmailTable(false)
      setShowNotificationTable(false)
      navigate(`/${roleName}/email-template`)
    } else if (e.target.value == "notification") {
      setShowNotificationTable(true)
      setShowSmsTable(false)
      setShowEmailTable(false)
      navigate(`/${roleName}/email-template`)
    } else {
      setShowEmailTable(false)
      setShowSmsTable(false)
      setShowNotificationTable(false)
      navigate(`/${roleName}/email-template`)
    }
  }

  const handleCustomerClicks = () => {
    navigate(`/${roleName}/email-template/add`)
  }

  const handleAddSMSClick = () => {
    navigate(`/${roleName}/sms-template/add`)
  }

  const handleAddNotificationClick = () => {
    navigate(`/${roleName}/notification-template/add`)
  }

  const handlePageChange = (
    page,
    pageSize,
    searchKey = searchValue,
    columnName = columnId,
    sortingOrder = sortingOrderStatus
  ) => {
    setPageSize(pageSize)
    getTemplate({ page, limit: pageSize, searchKey, columnName, sortingOrder })
      .then(responseFromAPI => {
        if (responseFromAPI.status && responseFromAPI.code == 200) {
          setTemplateList(responseFromAPI.data.data)
          const { totalItems, totalPages, currentPage } = responseFromAPI.data
          setPagination({
            pageIndex: currentPage,
            pageCount: totalPages,
            totalRecords: totalItems,
          })
        } else {
          setPagination({ pageIndex: 0, pageCount: 0, totalRecords: 0 })
          setTemplateList([])
        }
      })
      .catch(error => {

      })
  }

  const handlePageChangeForSMS = (
    page,
    pageSizeForSMS,
    searchKey = searchValueForSMS,
    columnName = columnIdForSMS,
    sortingOrder = sortingOrderStatusForSMS
  ) => {
    setPageSizeForSMS(pageSizeForSMS)
    getSMSTemplate({ page, limit: pageSizeForSMS, searchKey, columnName, sortingOrder })
      .then(responseFromAPI => {
        if (responseFromAPI.status && responseFromAPI.code == 200) {
          setSmsTemplateList(responseFromAPI.data.data)
          const { totalItems, totalPages, currentPage } = responseFromAPI.data
          setPaginationForSMS({
            pageIndex: currentPage,
            pageCount: totalPages,
            totalRecords: totalItems,
          })
        } else {
          setPaginationForSMS({ pageIndex: 0, pageCount: 0, totalRecords: 0 })
          setSmsTemplateList([])
        }
      })
      .catch(error => {

      })
  }
  const handlePageChangeForNotification = (
    page,
    pageSizeForNotification,
    searchKey = searchValueForNotification,
    columnName = columnIdForNotification,
    sortingOrder = sortingOrderStatusForNotification
  ) => {
    setPageSizeForNotification(pageSizeForNotification);
    getNotificationTemplate({ page, limit: pageSizeForNotification, searchKey, columnName, sortingOrder })
      .then(responseFromAPI => {
        if (responseFromAPI.status && responseFromAPI.code == 200) {
          setNotificationTemplateList(responseFromAPI.data.data)
          const { totalItems, totalPages, currentPage } = responseFromAPI.data
          setPaginationForNotification({
            pageIndex: currentPage,
            pageCount: totalPages,
            totalRecords: totalItems,
          })
        } else {
          setPaginationForNotification({ pageIndex: 0, pageCount: 0, totalRecords: 0 })
          setNotificationTemplateList([])
        }
      })
      .catch(error => {
        setNotificationTemplateList([])
      })
  }

  const handleSortColumn = option => {
    setSortingOptions(option)
    const columnName = option.column
    setColumnId(columnName)
    const sortingOrder = option.isAsc ? "asc" : "desc"
    setSortingOrderStatus(sortingOrder)
    handlePageChange(1, pageSize, searchValue, columnName, sortingOrder)
  }

  const handleSortColumnForSMS = option => {
    setSortingOptionsForSMS(option)
    const columnName = option.column
    setColumnIdForSMS(columnName)
    const sortingOrder = option.isAsc ? "asc" : "desc"
    setSortingOrderStatusForSMS(sortingOrder)
    handlePageChangeForSMS(1, pageSizeForSMS, searchValueForSMS, columnName, sortingOrder)
  }
  const handleSortColumnForNotification = option => {
    setSortingOptionsForNotification(option)
    const columnName = option.column
    setColumnIdForNotification(columnName)
    const sortingOrder = option.isAsc ? "asc" : "desc"
    setSortingOrderStatusForNotification(sortingOrder)
    handlePageChangeForNotification(1, pageSizeForNotification, searchValueForNotification, columnName, sortingOrder)
  }

  const handleSearchFilter = (value, pageSize) => {
    setSearchValue(value)
    handlePageChange(1, pageSize, value)
  }
  const handleSearchFilterforSMS = (value, pageSize) => {
    setSearchValueForSMS(value)
    handlePageChangeForSMS(1, pageSize, value)
  }
  const handleSearchFilterforNotification = (value, pageSize) => {
    setSearchValueForNotification(value)
    handlePageChangeForNotification(1, pageSize, value)
  }
  const handleClearSearch = () => {
    setSearchValue("")
    handlePageChange(1, pageSize, "", "id", "desc")
  }
  const handleClearSearchForSMS = () => {
    setSearchValueForSMS("")
    handlePageChangeForSMS(1, pageSizeForSMS, "", "id", "desc")
  }
  const handleClearSearchForNotification = () => {
    setSearchValueForNotification("")
    handlePageChangeForNotification(1, pageSizeForNotification, "", "id", "desc")
  }

  const buttonSection = (
    <div className="text-sm-end">
      <Button
        type="button"
        color="success"
        className="btn-rounded mb-2 me-2"
        onClick={handleCustomerClicks}
      >
        <i className="mdi mdi-plus me-1" />
        {'New Email Template'}
      </Button>
    </div>
  )
  const buttonSectionForSMS = (
    <div className="text-sm-end">
      <Button
        type="button"
        color="success"
        className="btn-rounded mb-2 me-2"
        onClick={handleAddSMSClick}
      >
        <i className="mdi mdi-plus me-1" />
        {'New SMS Template'}
      </Button>
    </div>
  )
  const buttonSectionForNotification = (
    <div className="text-sm-end">
      <Button
        type="button"
        color="success"
        className="btn-rounded mb-2 me-2"
        onClick={handleAddNotificationClick}
      >
        <i className="mdi mdi-plus me-1" />
        {'New Notification Template'}
      </Button>
    </div>
  )
  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="TEMPLATE LIST" />
        <Row className="vertical-scroll">
          <Col xs="12">
            <Card>
              <CardBody>
                <Col
                  md="2"
                  className="d-flex align-items-center"
                  style={{ width: "30%", marginBottom: "10px" }}
                >
                  <label className="mt-1 me-3 font-size-14">Template:</label>
                  <select
                    className="form-select"
                    onChange={handleInputChange}
                    value={selectedValue}
                  >
                    <option value="0">Select Template</option>
                    <option value="email">Email</option>
                    <option value="sms">SMS</option>
                    <option value="notification">Notification</option>
                  </select>
                </Col>

                {showEmailTable && (
                  <TableContainerV1
                    columns={columns}
                    data={templateList}
                    searchHelperText="Search by Email Type and Subject"
                    pagination={pagination}
                    handlePageChange={handlePageChange}
                    handleSearchFilter={handleSearchFilter}
                    customSection={buttonSection}
                    sortOptions={sortingOptions}
                    handleSortColumn={handleSortColumn}
                    handleClearSearch={handleClearSearch}
                    className="custom-header-css"
                  />
                )}
                {showSmsTable && (
                  <TableContainerV1
                    columns={SMScolumns}
                    data={smsTemplateList}
                    pagination={paginationForSMS}
                    searchHelperText="Search by SMS Type and Description"
                    handlePageChange={handlePageChangeForSMS}
                    handleSearchFilter={handleSearchFilterforSMS}
                    customSection={buttonSectionForSMS}
                    sortOptions={sortingOptionsForSMS}
                    handleSortColumn={handleSortColumnForSMS}
                    handleClearSearch={handleClearSearchForSMS}
                    className="custom-header-css"
                  />
                )}
                {showNotificationTable && (
                  <TableContainerV1
                    columns={Notificationcolumns}
                    data={notificationTemplateList}
                    pagination={paginationForNotification}
                    searchHelperText="Search by Notification Type and Purpose"
                    handlePageChange={handlePageChangeForNotification}
                    handleSearchFilter={handleSearchFilterforNotification}
                    customSection={buttonSectionForNotification}
                    sortOptions={sortingOptionsForNotification}
                    handleSortColumn={handleSortColumnForNotification}
                    handleClearSearch={handleClearSearchForNotification}
                    className="custom-header-css"
                  />
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default EmailTemplate
